import { useAsyncData, useRoute } from '#imports'

import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'

import { useRequests } from './useRequests'

export function useSeoLinks() {
  const requests = useRequests()
  const route = useRoute()

  // Trigger the request only when route.params changes, the page name does not matter
  return useAsyncData(
    getAsyncDataKey('reviews-link-booster', { path: route.params }),
    async () => {
      if (!requests || !('getSeoLinks' in requests) || !requests.getSeoLinks) {
        return null
      }

      return requests.getSeoLinks()
    },
    { watch: [() => route.params] },
  )
}
